<template>
  <b-container v-if="reference != null">
    <b-row>
      <b-col class="my-4">
        <router-link to="/" v-html="$t('backToOverview')" />
      </b-col>
      <b-col align-v="center" align-h="end" cols="auto" v-if="isInternalUser">
        <Rating class="mt-4" :rating="reference.referenceQuality | localize" />
      </b-col>
    </b-row>
    <h3>
      {{reference.title | localize}}
      <router-link :to="`/references/${this.id}/edit`" v-if="isAdmin">
        <b-button variant="light">
          <b-icon icon="pencil" variant="primary" />
        </b-button>
      </router-link>
    </h3>

    <h5>{{reference.subTitle | localize}}</h5>
    <div class="mt-3" v-if="headerImage.length>0">
      <img
        class="d-block img-fluid"
        style="width: 100%; height: 300px; object-fit: cover;"
        :src="headerImage[0]"
        alt="image slot"
      />
    </div>

    <ProjectInformation class="my-4" :reference="reference" />
  </b-container>
  <div v-else class="d-flex justify-content-center pt-5">
    <b-spinner variant="primary" />
  </div>
</template>

<script>
import { fetchAPI } from "../keecloak";
import Rating from "../components/Rating";
import ProjectInformation from "../components/ProjectInformation";
import currentUserMixin from "../current-user.js";

export default {
  name: "Reference",
  components: {
    Rating,
    ProjectInformation,
  },
  mixins: [currentUserMixin],
  props: {
    id: String,
  },
  data() {
    return {
      reference: null,
    };
  },
  computed: {
    currentLanguage() {
      return this.$i18n.locale;
    },
    headerImage() {
      return this.reference.attachedFiles
        .filter((file) => file.use.includes("HEADER"))
        .map(
          (file) =>
            `${process.env.VUE_APP_API_BASE_URL}/files/${file.id}?img_w=1920`
        );
    },
  },
  async created() {
    const res = await fetchAPI(`references/${this.id}`);
    if (res.ok) {
      this.reference = await res.json();
    } else {
      throw Error(res);
    }
  },
};
</script>

<style scoped>
h3 {
  text-transform: uppercase;
  color: #1aa5df;
  font-weight: bold;
  font-size: 22px;
}
h5 {
  margin-bottom: 10px;
  color: rgb(122, 122, 122);
}
</style>